import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './EquityTypeActionType';
import * as actions from './EquityTypeActions';
import * as services from './EquityTypeServices';

function* fetchEquityTypeDropdownSaga() {
    try {
        const response = yield call(services.getEquityTypeDropdown);
        yield put(actions.getEquityTypeDropdownSuccess(response.data?.items || []));
    } catch (error) {
        yield put(actions.getEquityTypeDropdownFailure(error));
    }
}

export default function* watchEquityTypeDropdownSaga() {
    yield takeLatest(types.GET_EQUITY_TYPE_DROPDOWN_REQUEST, fetchEquityTypeDropdownSaga);
}
